import { Drop, Eye, ListChecks } from '@phosphor-icons/react';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Callout } from '../components/Callout';
import { MediaFrame } from '../components/MediaFrame';
import { Reveal } from '../components/Reveal';
import { ResponsiveImage } from '../components/ResponsiveImage';
import { business } from '../content/site';

export function About() {
  const trustLine = business.trustMarks.join(' and ');

  return (
    <>
      <section className="about-owner section-shell">
        <Breadcrumbs items={[{ label: 'About' }]} />
        <div className="about-owner__grid">
          <Reveal variant="media">
            <MediaFrame className="about-owner__media">
              <ResponsiveImage
                src="/images/owner-projects/vic-owner-portrait.webp"
                alt="Vic, owner of Vic's Bricks, beside his work truck and business sign"
                width="1152"
                height="1152"
                fetchPriority="high"
                sizes="(max-width: 1023px) calc(100vw - 32px), min(46vw, 640px)"
              />
            </MediaFrame>
          </Reveal>
          <Reveal className="about-owner__copy" delay={0.08}>
            <p className="section-kicker">Owner-operated in Eastern North Carolina</p>
            <h1>Meet the owner.</h1>
            <p className="about-owner__intro">I’m Vic, owner of Vic’s Bricks, LLC.</p>
            <div className="about-owner__body">
              <p>I’m an NCCER-trained mason serving homeowners throughout Eastern North Carolina. I started Vic’s Bricks with a simple philosophy: do the work correctly, even the parts the customer will never see.</p>
              <p>A masonry project is only as good as what supports it. That means proper preparation, solid footings, drainage where needed, and taking the time to build something that’s meant to last.</p>
              <p>I want my customers to understand what they’re paying for, why I recommend what I recommend, and what goes into their project.</p>
              <p>Premium workmanship means caring about the details you see and the preparation you don’t. Clean lines, considered finishes, and properly prepared support belong in the same conversation.</p>
            </div>
            <blockquote className="about-owner__promise">My goal isn’t to be the cheapest mason. It’s to do work you should only have to pay for once.</blockquote>
          </Reveal>
        </div>
      </section>

      <section className="about-principles section-pad section-shell">
        <Reveal><Eye aria-hidden="true" size={28} weight="duotone" /><h2>See the whole space.</h2><p>The best-looking work begins with how the surface, pattern, edge, and surrounding property fit together.</p></Reveal>
        <Reveal delay={0.08}><Drop aria-hidden="true" size={28} weight="duotone" /><h2>Give water a path.</h2><p>Walls, slabs, entries, and masonry transitions last longer when runoff and incidental moisture are planned for.</p></Reveal>
        <Reveal delay={0.16}><ListChecks aria-hidden="true" size={28} weight="duotone" /><h2>Put the scope in plain language.</h2><p>Material, preparation, finish, cleanup, responsibilities, and use timing should be clear before construction starts.</p></Reveal>
      </section>

      <section className="about-credentials section-pad">
        <div className="about-credentials__grid section-shell">
          <Reveal><p className="section-kicker">{trustLine}</p><h2>Trained for the work. Attentive to the finish.</h2><p>Vic’s Bricks builds and repairs hardscapes, masonry, tile, concrete, and faux stone across Eastern North Carolina.</p></Reveal>
          <Reveal delay={0.08} variant="media">
            <MediaFrame className="about-credentials__media">
              <ResponsiveImage
                src="/images/owner-projects/vic-with-work-truck.webp"
                alt="Vic with his work truck and trailer in Eastern North Carolina"
                width="1024"
                height="640"
                sizes="(max-width: 1023px) calc(100vw - 32px), min(58vw, 760px)"
              />
            </MediaFrame>
          </Reveal>
        </div>
      </section>

      <section className="about-story section-pad">
        <div className="section-shell">
          <Reveal><h2>Local work, explained clearly.</h2><p>Whether the project is a new installation or a repair, you should understand what is being built, what belongs in the scope, and what site conditions shape the recommendation.</p></Reveal>
          <Reveal delay={0.08}><p className="about-story__statement">Firm ground is not a substitute for a prepared base or proper footing.</p><p>When the work calls for that support, Vic’s Bricks includes it in the scope, even when it adds cost, because better preparation supports a longer service life.</p></Reveal>
        </div>
      </section>
      <Callout />
    </>
  );
}
